<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active"><i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content" id="loader">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <b-button type="button" class="mr-2" variant="danger" @click="pauseAll"><i
                class="fas fa-pause"></i>&nbsp;Pause All
            </b-button>
            <b-button type="button" class="mr-2" variant="success" @click="resumeAll()"><i
                class="fas fa-play"></i>&nbsp;Resume All
            </b-button>
          </div>

        </div>
        <div class="row mt-3">
          <div v-for="(agg, url) in aggregators" class="col-sm-3" :key="url">
            <div class="card">
              <div class="card-body">
                <div>URL: {{ url }}</div>
                <div>Version: {{ agg !== null ? agg.version : 'n/a' }}</div>
                <div>Status: {{ agg !== null ? (agg.paused ? 'Paused' : 'Active') : 'Not Responding' }}</div>

                <div v-if="agg !== null" class="mt-2">
                  <b-button type="button" v-if="!agg.paused" class="mr-2" variant="danger" @click="pause(url)"><i
                      class="fas fa-pause"></i>&nbsp;Pause
                  </b-button>

                  <b-button type="button" v-else class="mr-2" variant="success" @click="resume(url)"><i
                      class="fas fa-play"></i>&nbsp;Resume
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-sm-12">

            <b-button type="button" v-if="halfPaused === true" class="mr-2" variant="danger"
              @click="halfPausedSwitch()"><i class="fas fa-pause"></i>&nbsp;Half Paused Off
            </b-button>
            <b-button type="button" v-else-if="halfPaused === false" class="mr-2" variant="success"
              @click="halfPausedSwitch()"><i class="fas fa-play"></i>&nbsp;Is Half Paused On
            </b-button>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-sm-12">
            <div v-if="inRelease !== null">inRelease set by {{ inRelease.ownerName }}({{ timeleft }})
              <br>
              <b-button type="button" class="mr-2" variant="danger" @click="inReleaseSwitch()"><i
                  class="fas fa-play"></i>&nbsp;End Deployment
              </b-button>
            </div>
            <b-button type="button" v-if="inRelease === null" class="mr-2" variant="success"
              @click="inReleaseSwitch()"><i class="fas fa-play"></i>&nbsp;Start Deployment
            </b-button>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getRouteIcon, ROUTE_AGGREGATOR } from "../../utils/routerIcons";

export default {
  data() {
    return {
      isPreparedTables: false,
      aggregators: {},
      isLoading: false,
      isPaused: null,
      halfPaused: null,
      pollingInterval: null,
      inRelease: null,
      loadingInstance: this.$veLoading({
        target: document.querySelector("#loader"),
        name: "wave",
      })
    }
  },
  computed: {
    timeleft() {
      if (!this.inRelease) {
        return;
      }
      const date = new Date(this.inRelease.time * 1000);
      const hours = String(date.getUTCHours()).padStart(2, '0');
      const minutes = String(date.getUTCMinutes()).padStart(2, '0');
      const seconds = String(date.getUTCSeconds()).padStart(2, '0');

      return `${hours}:${minutes}:${seconds}`;
    },
    userInRelease() {
      return localStorage.getItem('inRelease');
    },

    routeIcon: () => getRouteIcon(ROUTE_AGGREGATOR),
    user() {
      return this.$store.getters['currentUser'];
    },
  },
  methods: {
    pauseAll() {
      this.isLoading = true;
      this.loadingInstance.show()
      this
        .$http({ url: '/api/v1/aggregator-admin/pause-all', method: 'GET' })
        .then(() => this.isPaused = true)
        .then(this.getStatus)
        .catch((err) => {
          this.$toastr.e(JSON.stringify(err.response.data.message));
          throw err;
        })
        .finally(() => {
          this.isLoading = false;
          this.loadingInstance.close();
          this.getStatus();
        });
    },
    resumeAll() {
      this.isLoading = true;
      this.loadingInstance.show()
      this
        .$http({ url: '/api/v1/aggregator-admin/resume-all', method: 'GET' })
        .then(() => this.isPaused = false)
        .then(this.getStatus)
        .catch((err) => {
          this.$toastr.e(JSON.stringify(err.response.data.message));
          throw err;
        })
        .finally(() => {
          this.isLoading = false;
          this.loadingInstance.close();
          this.getStatus();
        });
    },
    pause(url) {
      this.isLoading = true;
      this.loadingInstance.show()
      this
        .$http({ url: '/api/v1/aggregator-admin/pause', method: 'POST', data: { url: url } })
        .then(() => this.isPaused = true)
        .then(this.getStatus)
        .catch((err) => {
          this.$toastr.e(JSON.stringify(err.response.data.message));
          throw err;
        })
        .finally(() => {
          this.isLoading = false;
          this.loadingInstance.close();
          this.getStatus();
        });
    },
    resume(url) {
      this.isLoading = true;
      this.loadingInstance.show()
      this
        .$http({ url: '/api/v1/aggregator-admin/resume', method: 'POST', data: { url: url } })
        .then(() => this.isPaused = false)
        .then(this.getStatus)
        .catch((err) => {
          this.$toastr.e(JSON.stringify(err.response.data.message));
          throw err;
        })
        .finally(() => {
          this.isLoading = false;
          this.loadingInstance.close();
          this.getStatus();
        });
    },
    getStatus() {
      this
        .$http({ url: '/api/v1/aggregator-admin', method: 'GET' })
        .then(resp => {
          this.aggregators = resp.data
        })
        .catch((err) => {
          this.$toastr.e(JSON.stringify(err.response.data.message));
          throw err;
        })
        .finally(() => {

        });
    },
    isHalfPausedAndInRelease() {
      this
        .$http({ url: '/api/v1/is-half-paused', method: 'GET' })
        .then(resp => {
          this.halfPaused = resp.data.isHalfPaused;
          this.inRelease = resp.data.inRelease;
        })
        .catch((err) => {
          this.$toastr.e(JSON.stringify(err.response.data.message));
          throw err;
        })
        .finally(() => {

        });
    },
    halfPausedSwitch() {
      this
        .$http({ url: '/api/v1/half-paused-switch', method: 'POST' })
        .then(resp => this.halfPaused = resp.data)
        .catch((err) => {
          this.$toastr.e(JSON.stringify(err.response.data.message));
          throw err;
        })
        .finally(() => {
          this.isHalfPausedAndInRelease();
        });
    },
    inReleaseSwitch() {
      this
        .$http({
          url: '/api/v1/in-release-switch',
          method: 'POST',
          data: {
            apiKey: process.env.VUE_APP_CHAT_API_KEY,
          },
        })
        .then(resp => this.halfPaused = resp.data)
        .catch((err) => {
          this.$toastr.e(JSON.stringify(err.response.data.message));
          throw err;
        })
        .finally(() => {
          this.isHalfPausedAndInRelease();
        });
    },
  },
  mounted() {
    this.getStatus();
    this.isHalfPausedAndInRelease();
    this.pollingInterval = setInterval(() => {
      this.isHalfPausedAndInRelease();
    }, 20000);
  },
  destroyed() {
    clearInterval(this.pollingInterval);
  }
}
</script>
